import montbookwoff from './mont-book-webfont.woff';
import montbookwoff2 from './mont-book-webfont.woff2';
import montbookotf from './mont-book.otf';
import montheavywoff from './mont-heavy-webfont.woff';
import montheavywoff2 from './mont-heavy-webfont.woff2';
import montheavyotf from './mont-heavy.otf';
import montsemiboldwoff from './mont-semibold-webfont.woff';
import montsemiboldwoff2 from './mont-semibold-webfont.woff2';
import montsemiboldotf from './mont-semibold.otf';
import waitingforthesunrisewoff from './WaitingfortheSunrise.woff'
import waitingforthesunrisewoff2 from './WaitingfortheSunrise.woff2'




const fonts = {
    montbook: {
        woff: montbookwoff,
        woff2: montbookwoff2,
        otf: montbookotf,
    },
    montheavy: {
        woff: montheavywoff,
        woff2: montheavywoff2,
        otf: montheavyotf,
    },
    montsemibold: {
        woff: montsemiboldwoff,
        woff2: montsemiboldwoff2,
        otf: montsemiboldotf,
    },
    waitingforthesunrise: {
        woff: waitingforthesunrisewoff,
        woff2: waitingforthesunrisewoff2,
    }
};

export default fonts;
